import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button, message } from 'antd';
import { getProfesseur, validateNumeroPaiement, requestNewOtp } from './personnel.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { InputOTP } from 'antd-input-otp';

export const PersonnelOtpModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const professeur = useAppSelector(state => state.professeur.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const id_ = props.match.params.id;
  const [otp, setOtp] = useState([]);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    dispatch(getProfesseur(id_));
  }, [id_]);

  useEffect(() => {
    if (professeur.keyExpirationTime) {
      const createdTime = new Date();
      const expirationTime = new Date(professeur.keyExpirationTime);
      const timeRemaining = Math.max(0, Math.floor((expirationTime.getTime() - createdTime.getTime()) / 1000)); // Convertir en secondes
      setTimeLeft(timeRemaining);

      const timer = setInterval(() => {
        setTimeLeft(prevTime => {
          if (prevTime <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [professeur.keyExpirationTime]);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/personnel/${currentEcole && currentEcole.id}/${id_}/details`);
  };

  const requestNewCode = () => {
    dispatch(requestNewOtp(id_))
      .then(() => {
        message.success('Un nouveau code a été envoyé.');
        dispatch(getProfesseur(id_));
      })
      .catch(() => {
        message.error("Échec de l'envoi du nouveau code. Veuillez réessayer.");
      });
  };

  const handleFinish = value => {
    const codeOTP = otp.join('') || value.join('');
    const entity = {
      ecoleId: currentEcole.id,
      validationKey: codeOTP,
      numeroTelephonePaiement: professeur.numeroTelephonePaiement,
    };
    dispatch(validateNumeroPaiement(entity)).then(() => {
      dispatch(getProfesseur(id_));
    });
    handleClose(value);
  };
  const goBack = () => {
    props.history.goBack();
    // props.history.push(`/professeur/${currentEcole && currentEcole.id}/${professeur.id}/details`);
  };
  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <>
      {professeur.numeroTelephonePaiement !== null && (
        <Modal
          title="Confirmation du numéro de paiement"
          className="center"
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
            <Button
              key="submit"
              disabled={timeLeft === 0}
              style={{ backgroundColor: 'green', color: 'white' }}
              onClick={value => handleFinish(value)}
            >
              Confirmer
            </Button>,
            <Button key="request-new" type="primary" onClick={requestNewCode} disabled={timeLeft > 0}>
              Renvoyer un nouveau code
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          <p className="center">
            Nous avons envoyé un code de vérification au{' '}
            <span style={{ color: '#F28E19', fontWeight: 'bold' }}> {professeur.numeroTelephonePaiement}</span>. <br /> Veuiller Saisir ce
            code ci-dessous
          </p>
          <InputOTP inputType="numeric" placeholder="x" length={4} onChange={setOtp} value={otp} />
          <span>
            {timeLeft === 0 ? (
              <p style={{ color: '#F28E19' }}>Le code a expiré </p>
            ) : (
              <p style={{ color: '#F28E19' }}>Le code expirera dans : {formatTime(timeLeft)}</p>
            )}
          </span>
        </Modal>
      )}
    </>
  );
};
export default PersonnelOtpModal;
